"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializeCognitoClient = void 0;
class InitializeCognitoClient {
    constructor(authService) {
        this.authService = authService;
    }
    execute(request) {
        const { config } = request;
        return this.authService.initializeCognitoClient(config);
    }
}
exports.InitializeCognitoClient = InitializeCognitoClient;
